import React, { Component } from 'react';
import SearchLayout from './SearchLayout';
import '../css/style.css';
import '../components/Home.css';
import EventPagingLayout from './EventPagingLayout';
import { translate } from "react-i18next";
import {GREEN_BG, GREEN_BORDER} from '../backend/Colors';

class MyEventFavoritesLayout extends Component {


    render() {
        const { t } = this.props;
        const { params } = this.props.match
        return (<SearchLayout title={t("Favorites")} eventKey="2" searchType="ACTIVTY" bg={GREEN_BG} bgStrong={GREEN_BORDER} >
            <EventPagingLayout preURL="events/myFav" id={params.id} />
        </SearchLayout>)
    }

}

export default translate("translations")(MyEventFavoritesLayout);